import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC } from 'react';
import { useDispatch } from 'react-redux';

import { TLocalesKeys as K } from '../../../../types';
import type { Announcement } from '../../../../types/domain';
import { hasContent } from '../../../../util/guards';
import { renderModel } from '../../../util/renderModel';
import { headerActions } from '../../reducers/header';
import { Button, CloseButton } from '../Button';
import { FullscreenDialog } from '../FullscreenDialog';
import { AlertCTAButton } from './AlertCTAButton';
import s from './styles.scss';

const isMobile = renderModel.isMobile();

export const Alert: FC<Announcement> = ({ errorMsg, label, url }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const close = () => {
    dispatch(headerActions.hideAlert());
    // TODO: add BI event
    // bi('close-alert');
  };

  const CTAButton = hasContent(label) && hasContent(url) && (
    <AlertCTAButton label={label} url={url} className={isMobile ? s.linkMobile : s.link} />
  );

  if (isMobile) {
    return (
      <FullscreenDialog close={close}>
        <div className={s.title}>{t<K>('alert_mobile_title')}</div>
        <div className={s.text}>{errorMsg}</div>
        {CTAButton}
        <Button primary onClick={close}>
          {t<K>('alert_mobile_contact_btn')}
        </Button>
      </FullscreenDialog>
    );
  }

  return (
    <div className={s.box}>
      <div className={s.content}>
        <div className={s.msg}>
          <div className={s.error} aria-live="polite" role="status">
            {errorMsg}
          </div>
          {CTAButton}
        </div>
        <CloseButton className={s.x} onClick={close} />
      </div>
    </div>
  );
};
